export class ResponseModel {
    response1: string
    response2: string
    history_sequence: number
    done_date: string

    constructor(
        response1: string,
        response2: string,
        history_sequence: number,
        done_date: string,
    ) {
        this.response1 = response1
        this.response2 = response2
        this.history_sequence = history_sequence
        this.done_date = done_date
    }
}